import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class RotateImageAction extends AbstractProvidedClass {
    isImageAction = true;

    constructor(provider) {
        super(provider);

        this.startAngle = this.image.center.angleTo(this.view.coordinate);
        this.oldAngle = this.image.rotation;
    }

    update() {
        this.image.rotation = this.oldAngle - this.startAngle + this.image.center.angleTo(this.view.coordinate);
    }

    finish() {
        this.newAngle = this.image.rotation;
        this.actions.finish();
    }

    undo() {
        this.image.rotation = this.oldAngle;
    }

    redo() {
        this.image.rotation = this.newAngle;
    }
}
